import React from 'react'
import { Button, useRefresh, useNotify, useUnselectAll, } from 'react-admin'
import IconBlock from '@material-ui/icons/Block'
import { rejectStarHealth } from '../../../Model/starHealth'


const handleAssignClick = (selectedIds, resource, refresh, notify, unselectAll) => {
    const data = {
        "sid[]": selectedIds,
    }
    rejectStarHealth(data, (res) => {
        refresh()
        unselectAll(resource)
        notify(res.message)
    }, (res) => {
        notify(res.message, 'warning')
    })

}

const BulkRejectButton = ({ selectedIds, resource }) => {
    const refresh = useRefresh()
    const notify = useNotify()
    const unselectAll = useUnselectAll()
    return (
        <Button label="Bulk Rejectw" style={{ color:'red',border:'1px solid'}} icon={<IconBlock />} onClick={() => {
            handleAssignClick(selectedIds, resource, refresh, notify, unselectAll)
        }} />
    );
}

export default BulkRejectButton